'use client'

import { Box, Flex } from '@mantine/core'
import { RebrandSearchIcon } from '@/components/Icons/Rebrand/SearchIcon'
import classes from './UniversalSearch.module.css'

interface SearchSubmitRowProps {
    /** Search text to submit. The row is hidden when this is empty. */
    query: string
    /** Called when the user taps the row to search for the current query. */
    onSubmit: () => void
    /** Use mobile for the larger row layout in the mobile panel. */
    variant?: 'default' | 'mobile'
}

/**
 * Runs a full search for the current query (navigates to search results).
 * On mobile typeahead it appears above suggestions; on desktop, below them.
 */
export function SearchSubmitRow({ query, onSubmit, variant = 'default' }: SearchSubmitRowProps) {
    const trimmedQuery = query.trim()
    if (!trimmedQuery) {
        return null
    }

    const isMobileVariant = variant === 'mobile'
    const iconSize = isMobileVariant ? 20 : 16
    const label = `Search \u201C${trimmedQuery}\u201D`

    if (isMobileVariant) {
        return (
            <button
                type="button"
                className={[classes.suggestionRow, classes.suggestionRowMobile].filter(Boolean).join(' ')}
                onClick={onSubmit}
            >
                <Box className={classes.suggestionIconMobile} aria-hidden>
                    <Flex align="center" justify="center" w="100%" h="100%">
                        <RebrandSearchIcon width={iconSize} height={iconSize} className={classes.rowIcon} />
                    </Flex>
                </Box>
                <span className={classes.suggestionRowTitle}>{label}</span>
            </button>
        )
    }

    return (
        <button type="button" className={classes.submitRow} onClick={onSubmit}>
            <span className={classes.rowIconBox} aria-hidden>
                <RebrandSearchIcon width={iconSize} height={iconSize} className={classes.rowIcon} />
            </span>
            <span className={classes.submitRowLabel}>{label}</span>
        </button>
    )
}
